import React, { useEffect, useState, useRef, useCallback } from 'react'
import { pageTitle } from '../../helper'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
import PostStyle2 from '../Post/PostStyle2'
import Div from '../Div'
import Spacing from '../Spacing'
import blogs from '../Pages/blogs.json'

export default function BlogPage() {
  pageTitle('Blog');
  const [visibleCount, setVisibleCount] = useState(10);
  const observerRef = useRef();

  // Callback to observe the last blog element
  const lastBlogElementRef = useCallback(node => {
    if (observerRef.current) observerRef.current.disconnect();
    observerRef.current = new IntersectionObserver(entries => {
      // If the last element is visible and there are more blogs, load 10 more
      if (entries[0].isIntersecting && visibleCount < blogs.length) {
        setVisibleCount(prev => prev + 10);
      }
    });
    if (node) observerRef.current.observe(node);
  }, [visibleCount]);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  // Only show blogs up to the current visibleCount
  const blogsToDisplay = blogs.slice(0, visibleCount);

  return (
    <>
      <PageHeading 
        title='Our Blog'
        bgSrc='/images/blog_hero_bg.jpeg'
        pageLinkText='Blog'
      />
      <Spacing lg='120' md='50'/>
      <Div className="container">
        <h3 style={{color: 'black'}}>Welcome to RBlog: The Evolution of Innovation and Insight</h3>
        <p>
          What started as a bold concept—<strong>Red Lips and Binary</strong>—has grown and evolved into something far more impactful and dynamic. From our early days of exploring the intersection of creativity and technology, we transformed into <strong>RLAB Group</strong>, a corporation dedicated to innovation, problem-solving, and pushing boundaries. Now, as we embrace our next chapter, we're proud to introduce <strong>RBlog</strong> —a reimagined space where insights, ideas, and thought leadership come together to inspire, inform, and ignite new possibilities.
        </p>
        <p>
          RBlog is more than just a rebrand; it's the culmination of years of growth, learning, and collaboration. Here, we'll explore the latest in technology, culture, and business innovation—sharing stories that shape industries, spark conversation, and drive change. Whether you're a tech enthusiast, a business leader, or someone simply looking to explore new ideas, RBlog is your go-to destination for thoughtful content and forward-thinking perspectives.
        </p>
        <p>Welcome to the future of RBlog. We're excited to have you along for the journey.</p>
      </Div>
      <Spacing lg='120' md='50'/>
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-8">
          {blogsToDisplay.map((item, index) => {
            const isLastItem = index === blogsToDisplay.length - 1;
            return (
              <div key={index} ref={isLastItem ? lastBlogElementRef : null}>
                <PostStyle2 
                  thumb={item.image}
                  title={item.title}
                  date={item.posted}
                  category={item.category}
                  href={item.slug}
                />
                {blogsToDisplay.length > index + 1 && <Spacing lg='95' md='60'/>}
                <Spacing lg='60' md='40'/>
              </div>
            )
          })}
          </Div>
        </Div>
      </Div>
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <Cta 
          title='Let’s collaborate make <br />something <i>exceptional</i> together' 
          btnText='Apply For Meeting' 
          btnLink='/contact' 
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}
